import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicDownloadGuide from '../../RifoDesign/EpicDownloadGuide/epic.download.guide.vue';
import EpicFeaturesGrid3 from '../../RifoDesign/EpicFeaturesGrid3/epic.features.grid3.vue';

import EpicTextImgSection from '../../RifoDesign/EpicTextImgSection/epic.text.img.section.vue';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
        EpicDownloadGuide,
        EpicFeaturesGrid3,
        EpicTextImgSection,
        'layout': EpicStandardLayout
    }
})
export default class DownloadAppPage extends Vue {
    public title: string = 'DownloadAppPage';
    public configs = new CommonConfig();
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg3.jpg`;
    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
